import { Component } from '@angular/core';

@Component({
  template: `
    <div>Page not found</div>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  `]
})
export class InvalidPageComponent {}



// WEBPACK FOOTER //
// ./src/app/layout/invalid-page.component.ts